module.exports = __webpack_public_path__ + "assets/img/14_897.2878e481.jpg";